module.exports = __webpack_public_path__ + "img/default-avatar.6ab6949d.png";